import {GEOLOCATION_PERMISSION_DENIED_CODE} from "@/src/modules/core/lib/geolocation-platform";
import {useGeolocationStore} from "@/src/modules/core/store/geolocation";
import type {GeolocationFix, GeolocationStatus} from "@/src/modules/core/types/geolocation";

export type UseGeolocationResult = {
  status: GeolocationStatus;
  fix: GeolocationFix | null;
  error: GeolocationPositionError | null;
  isWatching: boolean;
  loading: boolean;
  latitude: number | null;
  longitude: number | null;
  accuracy: number | null;
  timestamp: number | null;
  altitude: number | null;
  altitudeAccuracy: number | null;
  heading: number | null;
  speed: number | null;
};

/** Subscribe to permission-denied block — re-renders when gate/submit lock should change. */
export function useLocationCaptureBlocked(): boolean {
  return useGeolocationStore(
    (state) =>
      state.status === "denied" ||
      state.error?.code === GEOLOCATION_PERMISSION_DENIED_CODE,
  );
}

export default function useGeolocation(): UseGeolocationResult {
  const status = useGeolocationStore((state) => state.status);
  const fix = useGeolocationStore((state) => state.fix);
  const error = useGeolocationStore((state) => state.error);
  const isWatching = useGeolocationStore((state) => state.isWatching);

  const loading = status === "idle" || status === "acquiring";

  return {
    status,
    fix,
    error,
    isWatching,
    loading,
    latitude: fix?.latitude ?? null,
    longitude: fix?.longitude ?? null,
    accuracy: fix?.accuracy ?? null,
    timestamp: fix?.timestamp ?? null,
    altitude: null,
    altitudeAccuracy: null,
    heading: null,
    speed: null,
  };
}
